// extracted by mini-css-extract-plugin
export default {"outer":"DownPointer_outer__GIlbn","scroll-down":"DownPointer_scroll-down__WU+7n"};